import { render, staticRenderFns } from "./AppointmentsControlButtons.vue?vue&type=template&id=0bf1f3f7&"
import script from "./AppointmentsControlButtons.vue?vue&type=script&lang=js&"
export * from "./AppointmentsControlButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports